import { memo } from 'react';
import { ArchiveIcon } from '@page/icons';

import { SectionPlaceholder, SectionPlaceholderProps } from './SectionPlaceholder';

export type SectionEmptyPlaceholderProps = SectionPlaceholderProps;

const SectionEmptyPlaceholderBase = ({
  title = 'No data',
  description = 'Once you have data, they’ll show up here.',
  icon = <ArchiveIcon className="size-14 fill-bg-inter-primary-disabled" />,
  ...props
}: SectionEmptyPlaceholderProps) => {
  return <SectionPlaceholder icon={icon} title={title} description={description} {...props} />;
};

export const SectionEmptyPlaceholder = memo(SectionEmptyPlaceholderBase);
